<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>David Groves PhD, DSc is Emeritus Professor at the University of Western Australia and Visiting Professor at China University of Geosciences Beijing. He is a Fellow of the Australian Academy of Science and has received numerous international medals and awards for his research and teaching in mineral deposit geology. On semi-retirement, he commenced writing novels using his international experience, with this being his sixth, including <em>Naughty in Pink</em> and its sequel <em>Naughty in Australia</em> for children and the two precursors to this novel entitled <em>The Plagues’ Protocol</em> and <em>King Solomon’s Gold</em> following his first novel <em>The Digital Apocalypse.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3c46b3a5